import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch,
    useSelector
} from 'react-redux';
import { GetCompanionList,
  LoadCompanionSchema,
  GetCompanionData,
  UpdateCompanionData } from '../../../actions/CompanionActions';
import CompanionSidebar from './CompanionSidebar2';
import NewCompanion from './NewCompanion';
import useScreenSize  from '../../../components/useScreenSize';
import CompanionGrid from './CompanionGrid';
import EditCompanion from './EditCompanion';


const CompanionPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [viewHeight, viewWidth] = useScreenSize();
    const [filteredData, setFilteredData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [columnDefinitions, setColumnDefinitions] = useState([]);
    const companionInfo = useSelector(state => state.companionInfo.value);
    const [showNewComp, setShowNewComp] = useState(false);
    const [showEditComp, setShowEditComp] = useState(false);
    const [schemaId, setSchemaId] = useState(0);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [currentSchema, setCurrentSchema] = useState(undefined);
    const [compEdit, setCompEdit] = useState(0);
    const [currentComp, setCurrentComp] = useState({
      loaded: false,
      compName: '',
      compId: 0
    });

    useEffect(() => {
        if(companionInfo.loaded === false) {
            GetCompanionList(dispatch);
        }
    }, [companionInfo])

    useEffect(() => {
      let split = location.pathname.split("/");
      let lastPart = split[split.length - 1];
      if(!isNaN(lastPart))
      {
        if(currentComp.loaded === false || currentComp.compId !== parseInt(lastPart, 10))
        {
          LoadCompanionSchema(parseInt(lastPart, 10), receiveCompSchema);
          setSchemaId(parseInt(lastPart, 10));
        }
      } else {
        setCurrentComp({
        loaded: false,
        compName: '',
        compId: 0
      });
      }
    }, [location])

    const receiveCompSchema = (schema) => {
      setCurrentComp({
        loaded: true,
        compName: schema.companionName,
        compId: 999
      });

      let colDef = [];
      schema.columnData.forEach((sch) => {
        if(sch.columnName !== schema.identityColumn) {
          colDef.push({ field: sch.columnName, headerName: sch.columnDisplay, width: 200, singleClickEdit: true, editable: true, filter: "agTextColumnFilter", floatingFilter: !sch.isReadOnly })
        }
      });
      for (let record of schema.columnData) {
        record.filter = '';
      }
      setCurrentSchema(schema);
      console.log(schema);
      GetCompanionData(schema.companionId, receiveCompData, schema);

    }

  const receiveCompData = (data, schema) => {
    setAllData(data.records);
    console.log(data);
    let filter = [];
    if(data.records === null) return;
    for (let rec of data.records) {
        //if (filterCount < 100) {

      let dataObj = {};
      dataObj['rowId'] = rec.rowId;
      for (let ent of rec.entities)
      {
        //if(ent.colName !== schema.identityColumn) {
          dataObj[ent.colName] = ent.value;
        //}
      }
      filter.push(dataObj);
    }

    let colDef = [];
    console.log(schema.columnData);
    schema.columnData.forEach((sch) => {
      if(sch.isReadOnly || sch.columnName === schema.identityColumn)
      {
        colDef.push({ field: sch.columnName, headerName: sch.columnDisplay, width: 200, singleClickEdit: false, editable: false, filter: "agTextColumnFilter", floatingFilter: sch.isReadOnly })
      }
      else {
        colDef.push({ field: sch.columnName, headerName: sch.columnDisplay, width: 200, singleClickEdit: true, editable: true, filter: "agTextColumnFilter", floatingFilter: !sch.isReadOnly })
      }
    });
    for (let record of schema.columnData) {
      record.filter = '';
    }

      setColumnDefinitions(colDef);
      setFilteredData(filter);
      setIsDataLoading(false);
      console.log(filter);
  }

  const onRowDelete = (row) => {
    let data = allData;
    let rec = data.find(f => f.rowId === row.rowId);
    let changes = false;
    if(rec) {
      rec.isDeleted = true;
      changes = true;
    }
    if(changes)
    {
      setAllData(data);
    }
  }

  const handleSave = (edits) => {

      let dirtyRecords = [];
      let data = allData;

      if(edits)
      {
        let rec2 = allData.find(f => f.rowId === edits.rowId);
        if(rec2){
          rec2.entities.forEach(ent => {
            if(edits[ent.colName])
            {
              if(edits[ent.colName] !== ent.value){
                ent.value = edits[ent.colName];
                rec2.isDirty = true;
              }
            }
          });
        }
      }
      for (let rec of allData) {
        if (rec.isDirty || rec.isNew || rec.isDeleted) {
          dirtyRecords.push(rec);
        }
      }

      UpdateCompanionData(schemaId, dirtyRecords);
  }

  const onRowAdd = (row) => {
    let data = [...allData];
    let newRec = {rowId: row.rowId, entities: [], isDirty: false, isNew: true, isDeleted: false};
    let colDefs = columnDefinitions;
    colDefs.forEach(col => {
      let ent = {
        colIndex: row.rowId,
        colName: col.field,
        isReadOnly: false,
        value: row[col.field],
        isVisible: true,
      };
      newRec.entities.push(ent);

    });
    data.push(newRec);
    setAllData(data);
  }


  const onRowEdit = (row) => {
    console.log('edit2');
    console.log(row);
    console.log(viewHeight);
    let ad = [...filteredData];
    console.log(ad);
    let data = [...allData];
    let rec = data.find(f => f.rowId === row.rowId);
    let changes = false;
      if(rec) {
        console.log('update alldata');
        rec.entities.forEach(ent => {
          if(row[ent.colName])
          {
            if(row[ent.colName] !== ent.value){
              ent.value = row[ent.colName];
              rec.isDirty = true;
              changes = true;
            }
          }
        });
      }
      if(changes)
      {
        setAllData(data);
      }
    }

    const createItem = (id) => {
      let nextId = id;
      allData.forEach(item => {
        if(item.rowId <= nextId) nextId = item.rowId - 1;
      });
      let newItem = { rowId: nextId };
      columnDefinitions.forEach((f) => {
        newItem[f.field] = '';
      });

      return newItem;
    }

    const updateSchema = (schemaId) => {
      setCompEdit(schemaId);
      setShowEditComp(true);
    }

    return (
        <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <CompanionSidebar showNew={() => setShowNewComp(true)} UpdateSchema={updateSchema} />
            {currentComp.loaded === false &&
          <div className='h-100 d-flex align-items-center'>
            <div
              className='p-2 col-example'
              style={{
                textAlign: 'center',
                marginLeft: '100px',
                marginRight: '100px',
                width: '60%',
              }}
            >
              <i className='fa-solid fa-table fa-6x' />

              <h4 style={{ fontWeight: 'bolder', fontStyle: 'italic' }}>
                Companion Tables
              </h4>
            </div>
          </div>}

          {currentComp.loaded === true &&
            <div className='p-0' style={{width: `${viewWidth - 200}px`}}>
              <div className='card-header' >
              <h3>
                    <i className='fas fa-table' />{' '}
                    {currentComp.compName}
                  </h3>
                  </div>
                  {!isDataLoading &&
                  <CompanionGrid
                      data={filteredData}
                      createItem={createItem}
                      gridHeight={viewHeight -60}
                      columnDefs={columnDefinitions}
                      onRowEdit={onRowEdit}
                      onRowDelete={onRowDelete}
                      onRowAdd={onRowAdd}
                      onSave={handleSave}

                    />
                  }
            </div>
          }
        </div>
        {showNewComp &&
          <NewCompanion
            close={() => setShowNewComp(false)}
          />}
        {showEditComp &&
          <EditCompanion
            close={() => setShowEditComp(false)}
            schemaId={compEdit}
          />
        }
      </div>
    );
}

export default CompanionPage;